const GOOGLE_API_KEY = 'AIzaSyDDqiofmud1TeOXq6eHZGShJOsi4_4UBds';

export  {
  GOOGLE_API_KEY
}